import { useEffect, useRef } from "react";
import { OUR_WORK_IMAGES } from "./OurWorkImages";
import "../../styles/VerticalOurWork.css";

export default function HorizontalOurWork({ onBack }) {
  const containerRef = useRef(null);
  const x = useRef(0);
  const isRunningRef = useRef(true);

  useEffect(() => {
    const container = containerRef.current;
    let last = performance.now();
    const SPEED = 70; // 🔥 increased speed

    let raf;
    const animate = (now) => {
      if (!isRunningRef.current) return;

      const delta = (now - last) / 1000;
      last = now;

      x.current += SPEED * delta;

      const totalWidth = container.scrollWidth / 2;
      if (x.current >= totalWidth) x.current -= totalWidth;

      container.scrollLeft = x.current;
      raf = requestAnimationFrame(animate);
    };

    raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="container-fluid bg-dark py-4">
      {/* Horizontal Scroll */}
      <div ref={containerRef} className="horizontal-wrapper">
        {[...OUR_WORK_IMAGES, ...OUR_WORK_IMAGES].map((src, index) => (
          <div key={index} className="horizontal-item">
            <img src={src} alt="" draggable={false} />
          </div>
        ))}
      </div>

      {/* Back Button */}
      <div className="text-center mt-3">
        <button className="btn btn-secondary" onClick={onBack}>
          ← Back
        </button>
      </div>
    </div>
  );
}
